import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { getDictionary, getField } from '@/app/utils/translation/translation';


const ComputerContainer = {
    position: 'relative',
    maxWidth: '100%',
    overflow: 'hidden',
    margin: 'auto',
    display: "flex",
    justifyContent: "center",
};

function CloudixPlayer({ isMobile, translations, language }) {
    const dictionary = getDictionary(translations, 'media', language);

    const VideoPlayerWrapper = {
        position: 'absolute',
        transform: isMobile ? 'translate(0rem, 15%)' : 'translate(0%, 2.5rem)',
        width: '100%',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "25px",
        overflow: 'hidden',
    };
    const isArabic = language === 'arabic'
    return (
        <>
            <Box sx={{ marginTop: "3rem", transform: isMobile ? "" : "translateY(-5rem)" }}>
                <Container maxWidth="lg">
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <Typography
                                variant="h4"
                                fontSize={isMobile ? "1.5rem" : "2.5rem"}
                                component="h4"
                                align="center"
                                fontWeight="bold"
                                letterSpacing={isArabic ? '0px' : "3px"}
                                textAlign="center"
                                sx={{ color: "var(--text-primary)" }}
                                fontFamily="Century Gothic"
                            >
                                {isArabic ? (<> !{getField(dictionary, 'tap-to-play', language)}</>) : (
                                    <> {getField(dictionary, 'tap-to-play', language)}!</>
                                )}
                            </Typography>
                            <div style={ComputerContainer}>
                                <img
                                    src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/videoLap.png`}
                                    alt="Computer Screen"
                                    style={{
                                        display: 'block',
                                        width: isMobile ? '100%' : '80%',
                                        height: isMobile ? '100%' : '70%'
                                    }}
                                    loading="lazy"
                                />
                                <div style={VideoPlayerWrapper}>
                                    <video
                                        src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/videos/playervideo.mp4`}
                                        width={isMobile ? "79%" : "70%"}
                                        height="auto"
                                        controls
                                        muted={false}
                                        style={{ objectFit: "cover" }}
                                    />
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    );
}

export default CloudixPlayer;
